import {
  Button,
  Input,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  PopoverBody,
  UnorderedList,
  ListItem,
  InputGroup,
  InputLeftAddon,
  Box,
} from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTenant } from "modules/tenant/providers/tenant-provider";
import { useState } from "react";

const CompanyFieldsPopover = ({
  onClick,
  filters,
}: {
  onClick: (field: any) => void;
  filters: any;
}) => {
  const { user } = useTenant();

  const [filterText, setFilterText] = useState("");

  return (
    <Popover placement="top">
      <PopoverTrigger>
        <Button
          variant="ghost"
          w="100%"
          fontWeight="600"
          fontSize="14px"
          color="primary"
          leftIcon={<FontAwesomeIcon icon={["far", "plus"]} />}
        >
          Add additional filters
        </Button>
      </PopoverTrigger>
      <PopoverContent
        borderWidth="1.5px"
        borderColor="#E6E6E6"
        boxShadow="0px 0px 15px rgba(198, 198, 198, 0.25)"
      >
        <PopoverArrow />
        <PopoverBody p="0px">
          <Box p="12px" pb="0px">
            <InputGroup
              borderWidth="1.5px"
              borderColor="#E0E0E0"
              borderRadius="7px"
              // height="35px"
              lineHeight="22px"
              color="gray.300"
            >
              <InputLeftAddon pointerEvents="none" height="35px" pr="0px" pl="14px">
                <FontAwesomeIcon
                  fontSize="16px"
                  fontWeight="500"
                  icon={["far", "magnifying-glass"]}
                />
              </InputLeftAddon>
              <Input
                value={filterText}
                pl="8px"
                onChange={ev => setFilterText(ev.target.value)}
                placeholder="Search for filter..."
                variant="primary"
                fontWeight="500"
                border="none"
                height="35px"
                fontSize="14px"
                lineHeight="22px"
                color="gray.300"
              />
            </InputGroup>
          </Box>

          <UnorderedList
            maxHeight="280px"
            overflowY="scroll"
            listStyleType="none"
            p="0px"
            m="0px"
            my="12px"
          >
            {user.company.fields
              .filter((field: any) => field.label.toLowerCase().includes(filterText.toLowerCase()))
              .filter((field: any) => !filters[field.id])
              .map((field: any) => (
                <ListItem
                  key={field.id}
                  onClick={() => onClick(field)}
                  cursor="pointer"
                  color="secondary"
                  py="8px"
                  px="15px"
                  fontSize="14px"
                  fontWeight="400"
                  _hover={{
                    bg: "#F9F8F8",
                    borderRadius: "5px",
                  }}
                >
                  {field.label}
                </ListItem>
              ))}
          </UnorderedList>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};

export default CompanyFieldsPopover;
